const imgPinIcons = Array.from(document.querySelectorAll('.j-img-pin-icon'));

if (imgPinIcons) {
    imgPinIcons.forEach((item) => {
        item.addEventListener('click', () => {
            item.classList.toggle('is-active');
        });
    });
}

